// FILE: src/Components/Dashboard.js
import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Spin } from "antd";
import Sidebar from "./Sidebar";
import Header from "./Header";
import OnboardingChecklist from "./Dashboard/OnboardingChecklist";
import SignalsFeed from "./Dashboard/SignalsFeed";

const Calender = lazy(() => import("./Calender"));
const QueuePage = lazy(() => import("./QueuePage"));
const PublishPage = lazy(() => import("./PublishPage"));
const MediaLibrary = lazy(() => import("./Assets/MediaLibrary"));
const BrandKit = lazy(() => import("./BrandKit"));
const GroupsProfile = lazy(() => import("./GroupsProfile"));
const AccountSetting = lazy(() => import("./AccountSetting"));
const CreateCampagin = lazy(() => import("./CreateCampagin"));
const Inbox = lazy(() => import("./Inbox"));
const Message = lazy(() => import("./Message"));
const Konvatest = lazy(() => import("./Konvatest"));
const LinksDashboard = lazy(() => import("./Publishing/LinksDashboard"));
const ProfileReports = lazy(() => import("./Reports/ProfileReports"));
const PostReports = lazy(() => import("./Reports/PostReports"));

const AppsDashboard = lazy(() => import("./Apps/AppsDashboard"));
const BackgroundRemoverApp = lazy(() => import("./Apps/BackgroundRemoverApp"));
const CaptionGeneratorApp = lazy(() => import("./Apps/CaptionGeneratorApp"));
const AppsHistory = lazy(() => import("./Apps/AppsHistory"));
const ImageUpscalerApp = lazy(() => import("./Apps/ImageUpscalerApp"));
const MoodboardApp = lazy(() => import("./Apps/MoodboardApp"));
const ImageGeneratorApp = lazy(() => import("./Apps/ImageGeneratorApp"));
const ImageColorPaletteApp = lazy(() => import("./Apps/ImageColorPaletteApp"));
const ImageResizerApp = lazy(() => import("./Apps/ImageResizerApp"));
const ImageColorGradeApp = lazy(() => import("./Apps/ImageColorGradeApp"));
const CarouselMakerApp = lazy(() => import("./Apps/CarouselMakerApp"));

const AppRouteFallback = () => (
  <div className="flex h-full min-h-[60vh] items-center justify-center bg-gray-50">
    <Spin size="large" />
  </div>
);

const DashboardContent = () => (
  <div className="p-4 sm:p-6 lg:p-8">
    <Header />
    <OnboardingChecklist />
    <SignalsFeed />
  </div>
);

export default function Dashboard() {
  return (
    <div className="flex h-screen bg-gray-50">
      <div className="w-64 flex-shrink-0">
        <Sidebar />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto">
          <Suspense fallback={<AppRouteFallback />}>
            <Routes>
              <Route path="/" element={<DashboardContent />} />

              <Route path="/Publishing" element={<Calender />} />
              <Route path="/QueuePage" element={<QueuePage />} />
              <Route path="/PublishPost" element={<PublishPage />} />
              <Route path="/Links" element={<LinksDashboard />} />

              <Route path="/Apps" element={<AppsDashboard />} />
              <Route path="/Apps/background-remover" element={<BackgroundRemoverApp />} />
              <Route path="/Apps/caption-generator" element={<CaptionGeneratorApp />} />
              <Route path="/Apps/history" element={<AppsHistory />} />
              <Route path="/Apps/image-color-palette" element={<ImageColorPaletteApp />} />
              <Route path="/Apps/image-upscaler" element={<ImageUpscalerApp />} />
              <Route path="/Apps/image-resizer" element={<ImageResizerApp />} />
              <Route path="/Apps/image-color-grade" element={<ImageColorGradeApp />} />
              <Route path="/Apps/carousel-maker" element={<CarouselMakerApp />} />
              <Route path="/Apps/moodboard" element={<MoodboardApp />} />
              <Route path="/Apps/image-generator" element={<ImageGeneratorApp />} />

              <Route path="/Assets" element={<MediaLibrary />} />
              <Route path="/BrandKit" element={<BrandKit />} />
              <Route path="/GroupsProfile" element={<GroupsProfile />} />
              <Route path="/AccountSetting" element={<AccountSetting />} />
              <Route path="/ProfileReports" element={<ProfileReports />} />
              <Route path="/PostReports" element={<PostReports />} />
              <Route path="/Inbox" element={<Inbox />} />
              <Route path="/Campagin" element={<CreateCampagin />} />
              <Route path="/Message" element={<Message />} />
              <Route path="/Konva" element={<Konvatest />} />

              <Route path="*" element={<Navigate to="/Dashboard" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </div>
  );
}